














import { Component, Prop, Vue } from 'vue-property-decorator';
import TaftIcon from '@/components/base-layout/TaftIcon.vue';

@Component({
  components: { TaftIcon },
})
export default class SidebarMenuItem extends Vue {
  @Prop(String)
    route!: string;
  @Prop(String)
    text!: string;
  @Prop(String)
    icon!: string;
  @Prop(Boolean)
    hasSubItems!: boolean;
}
